import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  template: `
    <div class="modal-backdrop fade show" *ngIf="loadingService.mostrar$ | async">
      <div class="loading-container">
        <img class="loading-image" src="assets/img/layout/loading.gif" alt="Carregando" />
      </div>
    </div>
  `,
  styles: [
    `
      .modal-backdrop {
        position: fixed;
        inset: 0;
        z-index: 99999;
        background: rgba(128, 128, 128, 0.9);
      }

      .loading-container {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .loading-image {
        display: block;
      }
    `
  ]
})
export class LoadingComponent {
  constructor(public loadingService: LoadingService) {}
}
